import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=6a291684&scoped=true"
var script = {}
import style0 from "./Copy.vue?vue&type=style&index=0&id=6a291684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a291684",
  null
  
)

export default component.exports